export default {
  overviewTitle: 'Werk',
  detailTitle: 'Werk',
  deleteTitle: 'dit werk',
  defaultPerPage: 100,
  url: '/jobs',
  apiUrl: '/jobs/',
  sortBy: ['begin_timestamp'],
  sortDesc: [true],
  deletable: true,
  editable: true,
  duplicatable: true,
  multiSelect: false,
  filterName: 'jobs',
  quickFilter: {
    text: 'Zoek op klant, chauffeur',
    value: 'misc_search',
    type: 'text'
  },
  advancedSearchFields: [
    {text: 'Periode van', value: 'begin_timestamp_date_ge', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Periode tot', value: 'begin_timestamp_date_le', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Klant', value: 'customer_id', type: 'optionList', optionListName: 'customers', optionListParams: {is_active: true}, columns: 3, labelCols: 3, inputCols: 9},
    {text: 'Chauffeur', value: 'driver_id', type: 'optionList', optionListName: 'drivers', optionListParams: {is_active: true}, columns: 3, labelCols: 3, inputCols: 9},
    {text: 'Niet leeg', value: 'not_empty', type: 'boolean', columns: 1, labelCols: 9, inputCols: 3},
    {text: 'Niet gefactureerd', value: 'not_invoiced', type: 'boolean', columns: 1, labelCols: 9, inputCols: 3},
    {text: 'Firma', value: 'company_id', type: 'optionList', optionListName: 'companies', optionListParams: {is_active: true}, columns: 2, labelCols: 3, inputCols: 9},
    {text: 'Dossier', value: 'dossier', columns: 2, labelCols: 3, inputCols: 9},
    {text: 'Bestemming', value: 'destination', columns: 3, labelCols: 3, inputCols: 9},
    {text: 'Voertuig', value: 'truck_id', type: 'optionList', optionListName: 'vehicles', optionListParams: {is_active: true}, columns: 3, labelCols: 3, inputCols: 9},
    {text: 'Project Bestemming', value: 'project_destination', columns: 3, labelCols: 3, inputCols: 9},
    {text: 'Project CMR', value: 'project_cmr', columns: 3, labelCols: 3, inputCols: 9},
    {text: 'Project Nr', value: 'project_projectnr', columns: 3, labelCols: 3, inputCols: 9}
  ],
  newRecord: {
    km_empty_towards: 0,
    km_empty_back: 0,
    invoice_amount: 0,
    invoice_vatrate: 0,
    invoice_vat: 0,
    nrof_freights: 1,
    nights: 0,
    charter_amount: 0,
    surcharge_percentage: 0,
    invoice_base_amount: 0,
    diesel_surcharge_percentage: 0,
    km_tax_amount: 0,
    is_km_tax_tobeinvoiced: true,
    km_tax_invoiceamount: 0,
    is_underway: false,
    hours_worked_day: 0,
    hours_worked_night: 0,
    hours_compensation_day: 0,
    hours_compensation_night: 0,
    hours_overlap_day: 0,
    hours_overlap_night: 0,
    is_hour_not_known_yet: false,
    is_escort_checked: false,
    rests: [],
    projectjobs: [],
    hours_worked_total: 0,
    hours_compensation_total: 0,
    hours_overlap_total: 0
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'ID', value: 'id', link: '/jobs/{id}', width: '1%'},
    {text: 'Laden', value: 'begin_timestamp', filter: 'date', width: '8%'},
    {text: 'Uren', value: 'hours_worked_total', width: '1%'},
    // {text: 'Comp.', value: 'hours_compensation_total', width: '1%'},
    // {text: 'Overlap', value: 'hours_overlap_total', width: '1%'},
    // {text: 'Rust', value: 'hours_rest_total', width: '1%'},
    {text: 'Basis Excl', value: 'invoice_base_amount', width: '2%', align: 'right', filter: 'euro'},
    {text: 'Heffing Excl', value: 'km_tax_invoiceamount', width: '2%', align: 'right', filter: 'euro'},
    // {text: 'Excl', value: 'invoice_amount', width: '2%', align: 'right', filter: 'euro'},
    {text: 'Factuur', value: 'sale_invoice_nr', link: '/sales/{sale_id}', width: '6%'},
    {text: 'Firma', value: 'company_name', width: '4%'},
    {text: 'Klant', value: 'customer_name', width: '8%'},
    {text: 'Dossier', value: 'dossier', width: '6%'},
    {text: 'Voertuig', value: 'vehicle_nr', width: '1%'},
    {text: 'Laadbestemming', value: 'load_destination', width: '6%'},
    {text: 'Losbestemming', value: 'unload_destination', width: '6%'},
    {text: 'Lading', value: 'load_info', width: '5%'},
    {text: 'PF', value: 'projectsale_cnt', width: '1%'},
    {text: '#P', value: 'projectjob_cnt', width: '1%'},
    // {text: 'PNrs', value: 'projectnr_cnt', width: '2%'},
    {text: 'PNrs', value: 'projectnrs', width: '1%'},
    {text: 'Chauffeur', value: 'driver_full_name', width: '8%'}
    // {text: 'Factuur', value: 'sale_invoice_nr', link: '/jobs/{sale_id}', width: '4%'},
    // {text: 'Uren onbekend', value: 'is_hour_not_known_yet', type: 'boolean', width: '2%'},
    // {text: 'Remarks', value: 'remarks', width: '10%'},
    // {text: 'Km_Empty_Towards', value: 'km_empty_towards', width: '10%'},
    // {text: 'Km_Empty_Back', value: 'km_empty_back', width: '10%'},
    // {text: 'Invoice_Amount', value: 'invoice_amount', width: '10%'},
    // {text: 'Invoice_Vat', value: 'invoice_vat', width: '10%'},
    // {text: 'Nacht Uren', value: 'hours_worked_night', width: '2%'},
    // {text: 'Compensation_Hours_Day', value: 'hours_compensation_day', width: '10%'},
    // {text: 'Comp. Nacht Uren', value: 'hours_compensation_night', width: '2%'},
    // {text: 'Overlap_Hours_Day', value: 'hours_overlap_day', width: '10%'},
    // {text: 'Overlap_Hours_Night', value: 'hours_overlap_night', width: '10%'},
    // {text: 'Nachten', value: 'nights', width: '1%'}
    // {text: 'Charter_Amount', value: 'charter_amount', width: '10%'},
    // {text: 'Toeslag%', value: 'surcharge_percentage', width: '10%'},
    // {text: 'Invoice_Base_Amount', value: 'invoice_base_amount', width: '10%'},
    // {text: 'Is_Hour_Not_Known_Yet', value: 'is_hour_not_known_yet', type: 'boolean', width: '10%'},
    // {text: 'Diesel_Surcharge_Percentage', value: 'diesel_surcharge_percentage', width: '10%'},
    // {text: 'Km_Tax_Amount', value: 'km_tax_amount', width: '10%'},
    // {text: 'Is_Km_Tax_Tobeinvoiced', value: 'is_km_tax_tobeinvoiced', type: 'boolean', width: '10%'},
    // {text: 'Km_Tax_Invoiceamount', value: 'km_tax_invoiceamount', width: '10%'},
    // {text: 'Is_Underway', value: 'is_underway', type: 'boolean', width: '10%'},
    // {text: 'Customer_Begin_Time', value: 'customer_begin_timestamp', filter: 'time', width: '10%'},
    // {text: 'Is_Escort_Checked', value: 'is_escort_checked',  type: 'boolean', width: '10%'}
  ]
};
